<template>
  <el-table :data="gunDataTable" stripe style="width: 100%" ref="gunDataTable" border v-loading="listLoading">
    <!--                <af-table-column type="selection" width="30"></af-table-column>-->
    <af-table-column prop="lockId" width="120" label="地锁ID"></af-table-column>
    <af-table-column prop="stationName" width="180" label="所属场站"></af-table-column>
    <af-table-column prop="lockBrand" width="70" label="地锁品牌"></af-table-column>
    <af-table-column prop="lockModel" width="120" label="地锁型号" ></af-table-column>
    <af-table-column prop="gunCode" label="关联充电枪"></af-table-column>
    <af-table-column prop="battery" width="70" label="电量"></af-table-column>
    <af-table-column prop="billSwitch.message" width="70" label="计费"></af-table-column>
    <af-table-column prop="installTime" width="170" label="安装时间"></af-table-column>
    <af-table-column prop="alarmStatus.message" width="70" label="告警状态"></af-table-column>
    <af-table-column prop="lockStatus.message" width="70" label="地锁状态"></af-table-column>
    
    <af-table-column label="操作" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain v-if="scope.row.billSwitch && scope.row.billSwitch.code && scope.row.billSwitch.code == 'Y' " @click="billSwitch(scope.$index, scope.row)">关闭计费</el-button>
        <el-button size="mini" plain v-if="scope.row.billSwitch && scope.row.billSwitch.code && scope.row.billSwitch.code == 'N'" @click="billSwitch(scope.$index, scope.row)">开启计费</el-button>
        <!-- <el-button size="mini" @click="gunEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:gun:saveOrUpdateGunEdit'])">编辑
        </el-button> -->
        <!-- <el-button size="mini" v-if="scope.row.lockStatus.code == 0"  @click="gunDelete(scope.$index, scope.row)"
                  >升起
        </el-button>
        <el-button size="mini" v-if="scope.row.lockStatus.code == 1"  @click="gunDelete(scope.$index, scope.row)"
                  >降下
        </el-button> -->
        <el-button size="mini" type="danger" @click="gunDelete(scope.$index, scope.row)"
                  >删除
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{
      }
    },
    props:{
      gunDataTable:{},
      listLoading:false,
    },
    methods:{
      gunDetail(index,row){
        this.$emit("gunDetail",index,row)
      },
      gunEdit(index,row){
        this.$emit("gunEdit",index,row)
      },
      gunDelete(index,row){
        this.$emit("gunDelete",index,row)
      },
      billSwitch(index,row){
        this.$emit("billSwitch",index,row)
      }
    },
    filters: {
      stateFilter(state) {
        const statusMap = {
          '-1': 'info',  // 离线
          0: 'success',  // 空闲
          1: 'warning',     //启动充电中
          2: 'warning',    //充电进行中
          3: 'primary',   //充电结束
          4: 'danger',   //启动充电失败
          5: 'danger',   //预约充电中
          6: 'info'    //充电终端故障
        }
        return statusMap[state]
      },
      gunConnectionStateFilter(state) {
        if (state == null) {
          state = 1;
        }
        const statusMap = {
          0: 'info',  // 离线
          1: 'success',     //在线
        }
        return statusMap[state]
      },
      carConnectionStateFilter(state) {
        if (state == null) {
          state = 1;
        }
        const statusMap = {
          0: 'info',  // 断开
          1: 'success',     //连接
          2: 'success'     //半连接
        }
        return statusMap[state]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/parkingLockManager/list.vue